import { buildLifeAreaGoalListTree } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TreeItem } from 'shared/components/ui/virtualized-tree-list';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

export type Options = {
  hideArchived?: boolean;
  hideCompleted?: boolean;
};

export const useLifeAreaGoalListTree = (
  goals: Goal[],
  lifeAreas: LifeArea[],
  { hideArchived, hideCompleted }: Options,
) => {
  const { t } = useTranslation();
  const allGoals = useSortedGoals();

  return useMemo<Record<ID, TreeItem>>(
    () =>
      buildLifeAreaGoalListTree(goals, lifeAreas, {
        hideArchived,
        hideCompleted,
        archivedSectionName: 'Archived',
        otherLifeAreaName: t('general.sections.life-areas.other.title'),
        allGoals,
      }),
    [goals, allGoals, lifeAreas, t, hideArchived, hideCompleted],
  );
};
